import { ActionDeleteItem } from '../ActionDeleteItem/ActionDeleteItem'

type Operator = { id: number; name: string }

interface ActionDeleteOperatorItemProps<T extends Operator> {
  onDelete: (row: T) => Promise<void> | void
  displaySeparately?: boolean
}

export const ActionDeleteOperatorItem = <T extends Operator>({
  onDelete,
  displaySeparately = false
}: ActionDeleteOperatorItemProps<T>) => (
  <ActionDeleteItem
    onDelete={onDelete}
    displaySeparately={displaySeparately}
    successMessage={(row) => `Operator ${row.name} (${row.id}) deleted successfully`}
    errorMessage={(row) => `Failed to delete Operator ${row.name} (${row.id})`}
    confirmationMessage={(row) =>
      `Are you sure you want to delete Operator ${row.name} (${row.id})?`
    }
  />
)
